import React, { useContext,useEffect  } from "react";
import { Link,useNavigate  } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import CartLeft from "../components/Cart/CartLeft";
import CartRight from "../components/Cart/CartRight";
import { CartContext } from "../context/CartContext";

const Cart = () => {
	const { cart } = useContext(CartContext);
  const navigate = useNavigate();	
  const user = JSON.parse(localStorage.getItem("user")); // or from context

  useEffect(() => {
    if (user?.role === "individual" && user?.parent !== 0) {
      alert("Access to cart is restricted.");
      navigate("/"); // redirect to home or another allowed page
    }
  }, [user]);
  if (cart.length === 0) {
    return (
    <>  <BreadCrumb />
       <section className="section-space">
            <div className="container-xl">
            <div className="row">
                    <h1>Your cart is empty.</h1>
                </div>
               
            </div>
        </section>;
		 </>
  );
  }

  return (
    <>
       <BreadCrumb />
       <section className="section-space">
            <div className="container-xl">
            <div className="row">
                    <div className="col-lg-8">
                      <CartLeft />
                    </div>
                    <div className="col-lg-4">
                      <CartRight />
                    </div>
                </div>
               
            </div>
        </section>
    </>
  );
};

export default Cart